import * as React from "react";

const CustomerIcon: React.FC = () => {
    return (
        <svg
            width="39px"
            height="32px"
            viewBox="0 0 39 32"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.686 0C9.552 0 6.181 3.348 6.181 7.452c0 4.105 3.37 7.452 7.505 7.452 4.134 0 7.505-3.347 7.505-7.452 0-4.104-3.37-7.452-7.505-7.452zm0 1.753c3.18 0 5.74 2.542 5.74 5.7 0 3.157-2.56 5.698-5.74 5.698s-5.74-2.541-5.74-5.699c0-3.157 2.56-5.699 5.74-5.699zM28.696 5.7c-2.914 0-5.297 2.364-5.297 5.26 0 2.895 2.381 5.26 5.297 5.26 2.915 0 5.298-2.365 5.298-5.26 0-2.896-2.381-5.26-5.298-5.26zm0 1.753a3.506 3.506 0 110 7.014 3.506 3.506 0 110-7.014zM.441 29.781v.027c-.005.317.004.648.014.905a.88.88 0 00.883.849h3.077a.89.89 0 00.633-.254.874.874 0 00-.633-1.5H2.207c0-6.263 4.963-11.397 11.037-11.397h.883c6.074 0 11.037 5.134 11.037 11.397H7.947a.89.89 0 00-.633.252.871.871 0 000 1.248.89.89 0 00.633.254h18.087-.002a.88.88 0 00.883-.836c.017-.337.014-.606.014-.918 0-.746-.074-1.476-.193-2.191H37.51a.88.88 0 00.882-.836c.018-.334.014-.62.014-.918 0-4.96-4.146-8.767-9.27-8.767h-.884a9.365 9.365 0 00-6.264 2.37c-2.17-1.75-4.894-2.808-7.863-2.808h-.883C6.179 16.658.457 22.606.44 29.78zm27.814-10.932h.883c4.265 0 7.505 3.009 7.505 7.014h-10.32a13.294 13.294 0 00-3.035-5.192 7.562 7.562 0 014.967-1.822z"
                transform="translate(-452 -362) translate(407 347) translate(45 15)"
                fill="#09C"
                fillRule="nonzero"
                stroke="none"
                strokeWidth={1}
            />
        </svg>
    )
};
export default React.memo(CustomerIcon);
